module.exports = __webpack_public_path__ + "media/images/rating-93408df2eb072f2d5ca3894b68b2113c.svg";